import "../../../styles/systemMessage.scss";

import Icon, { iconTypes } from "./Icon";
import { messageType, removeSystemMessage } from "../actions/systemMessage.js";

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

class Message extends React.Component{
    constructor(props){
        super(props);

        this.onCloseMessage = this.onCloseMessage.bind(this);
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this);
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this);

        this.state = {
            timer: setTimeout( this.onCloseMessage, 10000 ),
        };
    }
    onMouseEnterHandler() {
        if( this.state.timer ) {
            clearTimeout(this.state.timer);
            this.setState({
                timer: null,
            });
        }
    }
    onMouseLeaveHandler() {
        if( this.state.timer ) {
            clearTimeout(this.state.timer);
        }
        this.setState({
            timer: setTimeout( this.onCloseMessage, 10000 )
        });
    }
    onCloseMessage() {
        this.props.removeSystemMessage(this.props.index);
    }
    render() {
        const {message, position, type} = this.props;
        return (
            <div className={`system-message-wrapper ${type===messageType.error?"message-type-error":"message-type-message"}`} style={{bottom:`${position}px`}} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                <div className="message">
                    {message}
                </div>
                <div onClick={this.onCloseMessage}>
                    <Icon type={iconTypes.x} className="right"/>
                </div>
            </div>
        );
    }
}

Message.propTypes = {
    removeSystemMessage: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
};



const mapStateToProps = state => {
    return {
        messages: state.systemMessage.messages,
    };
};
const mapDispatchToProps = {
    removeSystemMessage,
};
/**
 * Returnerar Icon node med icon kod inkluderad
 * @param {object} props
 * @returns {node}
 */
function SystemMessage({messages, removeSystemMessage}) {
    const nodes = [];
    for(let i=messages.length-1; i>=0; i--){
        nodes.push(
            <Message key={messages[i].key} index={i} message={messages[i].message} type={messages[i].type} position={8+i*47} removeSystemMessage={removeSystemMessage}/>
        );
    }
    return nodes;
}

SystemMessage.propTypes = {
    removeSystemMessage: PropTypes.func.isRequired,
    messages: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemMessage);